import { getBrowserFcmToken } from "@/services/push/firebase";

const STORAGE_KEY = "cajupe:two-factor-device-id";

function generateFallbackId() {
  return [
    Date.now().toString(36),
    Math.random().toString(36).slice(2),
    Math.random().toString(36).slice(2),
  ].join("-");
}

function generateDeviceId() {
  if (typeof window !== "undefined" && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes)
      .map((value) => value.toString(16).padStart(2, "0"))
      .join("");
  }

  return generateFallbackId();
}

export function getTwoFactorDeviceId() {
  if (typeof window === "undefined" || !window.localStorage) {
    return generateDeviceId();
  }

  const existing = window.localStorage.getItem(STORAGE_KEY);
  if (existing) {
    return existing;
  }

  const created = generateDeviceId();
  window.localStorage.setItem(STORAGE_KEY, created);
  return created;
}

export function setTwoFactorDeviceId(value) {
  const normalized = typeof value === "string" ? value.trim() : "";
  if (!normalized) {
    return null;
  }
  if (typeof window !== "undefined" && window.localStorage) {
    window.localStorage.setItem(STORAGE_KEY, normalized);
  }
  return normalized;
}

export async function getTwoFactorDeviceIdForTrust({
  requestPermission = false,
} = {}) {
  const token = await getBrowserFcmToken({ requestPermission }).catch(
    () => null
  );
  if (token) {
    return setTwoFactorDeviceId(`fcm:${token}`);
  }
  return getTwoFactorDeviceId();
}

export function withTwoFactorDevice(payload) {
  return {
    ...(payload || {}),
    identificacaoDispositivoAutenticacaoDoisFatores: getTwoFactorDeviceId(),
  };
}
